import { CustomAttributeTypeDTO } from '@/modules/common/types/dto/response/custom-attribute-response';

import { ReportFiltersRequest } from './dto';
import { ReportDimensionEntityDTO, ReportDimensionSourceDTO } from './report-dimension';

export enum ReportElementType {
  TABLE = 'TABLE',
  BAR_CHART = 'BAR_CHART',
  LINE_CHART = 'LINE_CHART',
  AREA_CHART = 'AREA_CHART',
  PIE_CHART = 'PIE_CHART',
  KPI_CARD = 'KPI_CARD',
  TEXT_BLOCK = 'TEXT_BLOCK',
}

export enum ReportScope {
  SYSTEM = 'SYSTEM',
  ORG = 'ORG',
  PRIVATE = 'PRIVATE',
}

export enum FormulaScope {
  USER = 'USER',
  ORG = 'ORG',
  SYSTEM = 'SYSTEM',
}

export enum MeasureType {
  HOURS = 'hours',
  MONEY = 'money',
  PERCENT = 'percent',
  RATIO = 'ratio',
  NUMBER = 'number',
}

export interface MeasureDefinition {
  key: string;
  label: string;
  type: string;
  dependsOn: string[];
  decimals?: number;
  unit?: string;
}

export interface DimensionDefinition {
  key: string;
  label: string;
  entity: ReportDimensionEntityDTO;
  source: ReportDimensionSourceDTO;
  customAttributeType: CustomAttributeTypeDTO | null;
  idKey: string;
  displayKey: string;
}

export interface PivotValue {
  key: string;
  label: string;
}

export type ColumnDefinition = MeasureDefinition | DimensionDefinition;

export interface DataRow {
  columns: Record<string, number | string | null>;
}

export interface ReportElement {
  id: string;
  type: ReportElementType;
  position: { x: number; y: number; width: number; height: number };
  reportType: string | null;
  columns: string[];
  groupBy: string[];
  pivotDimension: string | null;
  sortBy: string | null;
  sortOrder: string | null;
  config: Record<string, unknown>;
}

export interface Report {
  id: string;
  name: string;
  scope: ReportScope;
  createdAt: string;
  updatedAt: string;
  elements: ReportElement[];
}

export interface ReportData {
  measures: MeasureDefinition[];
  dimensions: DimensionDefinition[];
  pivotDimension?: DimensionDefinition;
  pivotValues?: PivotValue[];
  rows: DataRow[];
  totalsRow?: Record<string, number | string | null>;
  groupSummaryRows?: Record<string, number | string | null>[];
  totalCount?: number;
  averageValue?: number;
}

export interface FormulaLibraryEntry {
  id: string;
  scope: FormulaScope;
  key: string;
  label: string;
  formulaString: string;
  dependsOn: string[];
  measureType: string;
  defaultAggFormula?: string;
  createdAt: string;
  updatedAt: string;
}

export interface DateFilter {
  dateFrom?: string;
  dateTo?: string;
  projectIds?: number[];
  memberIds?: number[];
  /** Filters added from the filter dropdown (attributes of members / projects) */
  filters?: ReportFiltersRequest;
}
